/**
 * One look at the thing itself, on the home page.
 *
 * A control plane is an abstract noun, and four cards of abstract nouns is a
 * page a reader believes or does not with nothing to go on. The terminal wall is
 * the moment the product stops being a category: real sessions, on real
 * machines, running the provider's own CLI, with a person able to take the
 * keyboard. It is the single most convincing object on the site, so the home
 * page shows it and the product page explains it.
 *
 * The figure is the execution section's, reused rather than redrawn. It is fed
 * from `src/data/fixtures.ts` like every other figure here — never a screenshot,
 * because `artifacts/screenshots/` carries live operator addresses and
 * `fixtures.test.ts` greps for exactly that kind of leak.
 */
import { Reveal } from '../kit'
import { useLocale, useT } from '../i18n/context'
import { TerminalWall } from '../figures/exec/TerminalWall'
import { FigureFrame } from './Section'
import { pathFor } from '../routes'

export function Showcase() {
  const t = useT()
  const locale = useLocale()

  return (
    <section className="kl-section kl-section--sunken kl-showcase" aria-labelledby="showcase-title">
      <div className="kl-inner">
        <Reveal className="kl-head">
          <p className="k-eyebrow">
            <span className="k-label">{t('home.showcase.eyebrow')}</span>
          </p>
          <h2 id="showcase-title" className="kl-title">
            {t('home.showcase.title')}
          </h2>
          <p className="kl-sub">{t('home.showcase.sub')}</p>
        </Reveal>

        <div className="kl-section__figure">
          <FigureFrame alt={t('exec.fig.alt')}>
            <TerminalWall />
          </FigureFrame>
        </div>

        <p className="kl-showcase__more">
          <a className="kl-textlink" href={`${pathFor(locale, 'product')}#execution`}>
            {t('home.showcase.link')}
          </a>
        </p>
      </div>
    </section>
  )
}
